export enum TruncateLocation {
    File,
    End
}